//Promo standard
var promoGridItems = $('.promo-grid-inner.grid-container .promo-grid-items');
if (promoGridItems.length > 0) {
  promoGridItems.slick({
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,

        }
      }
    ],
  });

  $(window).on('load resize orientationchange', function () {
    if ($(window).width() > 768) {
      if (promoGridItems.hasClass('slick-initialized')) {
        promoGridItems.slick('unslick');
      }
    }
    else {
      if (!promoGridItems.hasClass('slick-initialized')) {
        promoGridItems.slick({
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
        });
      }
    }
  });
}
